(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Hegna",
                {
                    url: "/Hegna",
                    component: "hegna",
                    PageTitle: "Retire Happy Now",
                    requiredPermissions: "HegnaRHN:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("hegna",
        {
            templateUrl: "App/Resources/Hegna/hegna-template.html",
            controller: hegnaCtrl,
            bindings: {
                states: "<"
            }
        });

    hegnaCtrl.$inject = ["$http", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "permissionService", "userApi", "purchaseApi", "$mdDialog", "$interval", "$filter", "wistiaApi", "_", "amplitudeService"];

    function hegnaCtrl($http, eligibilityFormDialog, surveys, eligibilityFormApi, permissionService, userApi, purchaseApi, $mdDialog, $interval, $filter, wistiaApi, _, amplitudeService) {
        var $ctrl = this;

        $ctrl.hegnaDisclaimer = 
        "<br /><br /><strong>DISCLAIMER</strong>: By clicking the Tier of the program you wish to participate in you accept and agree to all payment terms related thereto.Moreover, you agree to the terms of the Hegna Program Membership Agreement including, without limitation, those relating to the ownership or otherwise of any and all intellectual property related to this program, executed contemporaneous herewith and incorporated herein.";

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.intervals = [];
        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.retireHappyNowTierIId).then(function (submitted) {
                $ctrl.submitted = submitted;
            });
        });

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {

            var disclaimer = "By clicking \"SUBMIT\" below, you agree to the following terms of agreement:" +
                $ctrl.hegnaDisclaimer;
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.retireHappyNowTierIId, disclaimer).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        };

        $ctrl.verifyPurchased = function () {
            $ctrl.purchased = null;
            var o = null;
            return userApi.getLoggedInUser().then(function (user) {
                return purchaseApi.getUserOrders(user.Id).then(function (orders) {

                    //console.log(orders)
                    ng.forEach(orders,
                        function (order) {
                            if (order.MarketingStrategy === "HegnaRHNTierII") {
                                var d = new Date(order.CompletedDate);
                                var n = d.toLocaleDateString();
                                order.PurchaseDate = n;
                                purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                    if (strategy.DocusignUrl != null)
                                        order.DocusignUrl = strategy.DocusignUrl;
                                });
                                o = order;
                                console.log(o);
                            }

                            else if (order.MarketingStrategy === "HegnaRHNTierIII") {
                                var d = new Date(order.CompletedDate);
                                var n = d.toLocaleDateString();
                                order.PurchaseDate = n;
                                purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                    if (strategy.DocusignUrl != null)
                                        order.DocusignUrl = strategy.DocusignUrl;
                                });
                                o = order;
                                console.log(o);
                            }
                        });

                    if (o !== null) {
                        ng.forEach($ctrl.intervals,
                            function (interval) {
                                $interval.cancel(interval);
                            });
                        $ctrl.purchased = o;
                    }

                });
            });
        };

        $ctrl.loadResources = function () {
            if (permissionService.hasOnePermission("HegnaRHNTierI:Access|HegnaRHNTierII:Access|HegnaRHNTierIII:Access")) {
                $ctrl.loadingAssets = true;
                wistiaApi.getHegnaAssets().then(function (response) {

                    var projectMedias = response.medias;
                    var wistiaAssets = [];

                    var uniqueMedias = $filter("unique")(projectMedias, "section");
                    ng.forEach(uniqueMedias,
                        function (value, key) {
                            var newAsset =
                            {
                                Title: value.section,
                                Active: uniqueMedias.length > 1 ? true : false,
                                Medias: $filter("filter")(projectMedias, { section: value.section })
                            };
                            wistiaAssets.push(newAsset);
                        });                  

                    //if user not enrolled in III, don't show tier III's assets
                    if (!permissionService.hasOnePermission("HegnaRHNTierIII:Access")) {
                        wistiaAssets = _.reject(wistiaAssets, function (val) { return val.Title === 'Tier 3 Assets'; });

                        //if user not enrolled in II, don't show tier II's assets
                        if (!permissionService.hasOnePermission("HegnaRHNTierII:Access")) {
                            wistiaAssets = _.reject(wistiaAssets, function (val) { return val.Title === 'Tier 2 Assets'; });
                        }
                    }
                    
                    $ctrl.Assets = wistiaAssets;                    

                }).then(function () {
                    $ctrl.loadingAssets = false;
                });
            }
        };

        $ctrl.openPurchaseDialog = function (event, ms) {

            var disclaimer = "By clicking \"Purchase\" below, you agree to the following terms of agreement:" +
                $ctrl.hegnaDisclaimer;

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    purchased: false,
                    orders: purchaseApi.getAllOrders(),
                    title: "Retire Happy Now - Tom Hegna",
                    //purchaseOptions: [{ Description: "Force CRM - Monthly Recurring Payments", Amount: 99, IsRecurringPayment: true }],
                    purchaseOptions: [
                        {
                            Description: "Retire Happy Now Tier II",
                            Amount: 2999,
                            IsRecurringPayment: false,
                            Selected: (ms === "HegnaRHNTierII" ? true : false),
                            MarketingStrategy: "HegnaRHNTierII"
                        },
                        {
                            Description: "Retire Happy Now Tier III",
                            Amount: 6999,
                            IsRecurringPayment: false,
                            Selected: (ms === "HegnaRHNTierIII" ? true : false),
                            MarketingStrategy: "HegnaRHNTierIII"
                        }
                    ],
                    disclaimer: disclaimer,
                    termsLink: "https://www.figmarketing.com/Documents/Terms_of_Use.pdf",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop)
                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        },
                            3000)
                    );
                } else $ctrl.verifyPurchased();
            });
        };
        $ctrl.$onInit = function () {
            $ctrl.loadResources();
            $ctrl.verifyPurchased();
        };
    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window", "$timeout"];
    function dialogCtrl($mdDialog, purchaseApi, $window, $timeout) {
        var $ctrl = this;
        window.d = this;
        ng.extend($ctrl,
            {
                close: close,
                cancel: cancel,
                purchase: purchase,
                getPaymentAmount: getPaymentAmount,
                setup: setup
            });

        function setup() {
            $ctrl.marketingDollarsToUse = 0;
            if ($ctrl.purchaseOptions) {

                if ($ctrl.purchaseOptions[0].Selected) {
                    $ctrl.selectedPurchaseOption = 0;
                    $ctrl.paymentAmount = $ctrl.purchaseOptions[0].Amount;
                }


                if ($ctrl.purchaseOptions[1].Selected) {
                    $ctrl.selectedPurchaseOption = 1;
                    $ctrl.paymentAmount = $ctrl.purchaseOptions[1].Amount;
                }
            }
        }

        $ctrl.setup();

        function getPaymentAmount() {

            var preMarketingDollarPrice = ($ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount);

            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > preMarketingDollarPrice) {
                $ctrl.marketingDollarsToUse = preMarketingDollarPrice;
            }

            if ($ctrl.marketingDollarsToUse === null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = preMarketingDollarPrice - $ctrl.marketingDollarsToUse;
        }

        function purchase(model) {
            $ctrl.submittingOrder = true;
            $ctrl.error = false;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].MarketingStrategy;
            order.Total = ($ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount);
            order.AdditionalInfo = {};

            if ($ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].IsRecurringPayment)
                order.Frequency = 3;
            else
                order.Frequency = 0;

            return purchaseApi.purchase(order)
                .then(function (response) {

                    $ctrl.submittingOrder = false;
                    close($ctrl.paymentAmount);

                    if ($ctrl.paymentAmount > 0) {
                        $window.open(response, "_blank");
                        //$window.location.href = "/";       
                    }
                }).catch(function (error) {
                    console.log(error);
                    $ctrl.submittingOrder = false;
                    $ctrl.error = true;
                });
        }

        function close(paymentAmount) {
            $mdDialog.hide(paymentAmount);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})(window.app, window.angular); // jshint ignore:line